// extracted by mini-css-extract-plugin
export default {"home":"home_home__6zGs6","sideStrips":"home_sideStrips__KvKf+","sideStrips2":"home_sideStrips2__Dsmqj","sideStrips3":"home_sideStrips3__ascX-"};